<!-- 趣味测评详情 -->
<template>
  <div
    class="container funIntro"
    :style="{
      background: `url(${infoData.detail.detailImageUrl})`,
      'background-repeat': 'no-repeat',
      'background-size': '100% auto',
      paddingTop: platform == 'app' ? `${statusBarHeight}vw` : 0,
    }"
  >
    <!-- <img class="pageImg" :src="infoData.detail.detailImageUrl" alt="" /> -->
    <div class="navigator" v-if="platform == 'app'">
      <div class="back_share">
        <img
          class="back_img"
          src="@/assets/images/home/back@2x.png"
          @click="back()"
          @touchmove.stop.prevent
          alt
        />
        <img
          @click.stop="shareHandle()"
          class="share_img"
          src="@/assets/images/home/share.png"
          alt
        />
      </div>
      <!-- <button @click="bridgeStatusBar">测试StatusBarHeight</button>
      <button @click="bridgeClose">测试back</button>
      <button @click="bridgeRoute('/moduleApp/AiCallActivity')">
        测试router
      </button> -->
    </div>
    <!-- 基础信息 -->
    <div class="pageContent" ref="pageContent">
      <div class="blank_box" ref="BBRef"></div>
      <div class="content">
        <div class="content_top">
          <div class="price_number">
            <div class="price_box">
              <template  v-if="infoData.paid"
              >
              <span class="free_text">限时免费</span>
              <span  :class="infoData.paid ? 'free_price_text' : 'price_text'"
                >官方指导价格：{{ infoData.price }}</span
              >
              </template>
              <span v-else>免费</span>
            </div>
            <div class="number_box">
              <div class="total_num">
                <img src="@/assets/images/home/total_icon.png" alt="" />
                <span>{{ infoData.questionTotal }}题</span>
              </div>
              <div class="person_num">
                <img src="@/assets/images/home/number_icon.png" alt="" />
                <span>{{ infoData.assessTimes }}人测过</span>
              </div>
            </div>
          </div>
          <div class="question">
            {{ infoData.title }}
          </div>
        </div>
        <div class="content_box">
          <div class="module_box">
            <!-- 模块名称 -->
            <div class="content_title">
              <div class="title_line"></div>
              <div class="title_text">{{ infoData.detail.moduleTitle }}</div>
            </div>
            <!-- 总述 -->
            <div class="content_summary">
              {{ infoData.detail.moduleOverview }}
            </div>
            <div class="type_box">
              <!-- 图片型 -->
              <img
                v-if="infoData.detail.type == 'IMAGE' && infoData.detail.moduleImageUrl"
                class="content_img"
                :src="infoData.detail.moduleImageUrl"
                alt=""
              />
              <!-- 分条描述型 -->
              <div
                class="content_description"
                v-if="infoData.detail.type == 'STEP' && infoData.detail.moduleContent[0]!==''"
              >
                <div
                  class="desc_item"
                  v-for="(item, index) in infoData.detail.moduleContent"
                  :key="index"
                >
                  <img
                    class="desc_icon"
                    :src="
                      require(`@/assets/images/home/desc_icon${index >2 ? 3 : index + 1}.png`)
                    "
                    alt=""
                  />
                  <div class="desc_title">
                    <div class="desc_text">{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 总结 -->
            <div
              class="content_conclusion"
              v-if="infoData.detail.moduleSummary"
            >
              {{ infoData.detail.moduleSummary }}
            </div>
          </div>
          <div class="module_box">
            <!-- 模块名称 -->
            <div class="content_title">
              <div class="title_line"></div>
              <div class="title_text">适合谁测</div>
            </div>
            <!-- 总述 -->
            <div class="content_summary">
              {{ infoData.detail.suitableOverview }}
            </div>
            <div class="type_box" v-if="infoData.detail.suitableContent.length>0&&infoData.detail.suitableContent[0]!==''">
              <!-- 分条描述型 -->
              <div class="content_description">
                <div
                  class="desc_item"
                  v-for="(item, index) in infoData.detail.suitableContent"
                  :key="index"
                >
                  <img
                    class="desc_icon"
                    :src="
                      require(`@/assets/images/home/desc_icon${index >2 ? 3 : index + 1}.png`)
                    "
                    alt=""
                  />
                  <div class="desc_title">
                    <div class="desc_text">{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 总结 -->
            <div class="content_conclusion2" v-if="infoData.detail.suitableSummary">
              <div class="content_conclusion_bg">
                <div class="content_conclusion_text1">
                  {{ infoData.detail.suitableSummary }}
                </div>
              </div>
              <div class="content_conclusion_text2">
                {{ infoData.detail.suitableSummary }}
              </div>
            </div>
          </div>
          <div class="module_box">
            <!-- 模块名称 -->
            <div class="content_title">
              <div class="title_line"></div>
              <div class="title_text">你将获得</div>
            </div>
            <div class="type_box">
              <!-- 分条描述型 -->
              <div class="content_description content_description_2">
                <div
                  class="desc_item"
                  v-for="(item, index) in infoData.detail.obtainContent"
                  :key="index"
                >
                  <img
                    class="desc_icon"
                    :src="
                      require(`@/assets/images/home/desc_icon${index >2 ? 3 : index + 1}.png`)
                    "
                    alt=""
                  />
                  <div class="desc_title">
                    <div class="desc_text">{{ item }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="module_box" v-if="infoData.detail.referencesText">
            <!-- 参考文献 -->
            <div class="content_title">
              <div class="title_line"></div>
              <div class="title_text">参考文献</div>
            </div>
            <div class="reference_box">
              <div class="reference_item enter_style">{{ infoData.detail.referencesText }}
              </div>
              <!-- <div class="reference_item">
                {{ references }}
              </div> -->
            </div>
          </div>
        </div>
        <!-- 相关推荐 -->
        <div class="recommend" v-if="recommendList.length > 0">
          <img
            class="recommend_img"
            src="@/assets/images/home/recommend.png"
            alt=""
          />
          <div class="recommend_box">
            <div
              class="recommend_item"
              v-for="(item, index) in recommendList"
              :key="index"
              @click="reduceUrl(item)"
            >
              <img class="recommend_item_img" :src="item.imageUrl" alt="" />
              <div class="recommend_item_content">
                <div class="recommend_item_title">{{ item.title }}</div>
                <div class="recommend_item_subTitle">{{ item.subtitle }}</div>
                <div class="recommend_item_person_price">
                  <div class="recommend_item_personNum">
                    <img
                      class="recommend_item_personNum_icon"
                      src="@/assets/images/home/person_icon.png"
                      alt=""
                    />
                    <span class="recommend_item_personNum_text"
                      >{{ item.assessTimes }}人测过</span
                    >
                  </div>
                  <div class="recommend_item_price">
                    <span class="recommend_free_text">免费</span
                    >

                    <span
                      v-if="item.paid"
                      :class="
                        item.paid
                          ? 'recommend_item_price_free'
                          : 'recommend_item_price_normal'
                      "
                      >￥{{ item.price }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 操作按钮 -->
      <div class="btn_box">
        <van-button type="default" class="btn_item" @click="toAnswer">{{
          infoData.latestAnswerId ? "再测一次" : "开始测试"
        }}</van-button>
        <van-button
          type="default"
          class="btn_item"
          v-if="infoData.latestAnswerId"
          @click="toReport"
          >查看报告</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getFunInfo, getRecommend } from "@/api/home";
export default {
  props: {
    type: {
      type: Number,
      default: 1,
    },
    id: {
      type: [Number, String],
      default: null,
    },
  },
  components: {},
  data() {
    // 这里存放数据
    return {
      infoData: {}, // 测评详情数据
      bgImg: require("@/assets/images/home/pageBg.png"),
      iconPath: "@/assets/images/home/desc_icon",
      recommendList: [], // 推荐测评列表
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    reduceUrl(item) {
      console.log("---相关推荐", item);
      const id = item.id;
      const type = item.category === "FUN" ? 1 : 2;
      // 重定向
      this.$router.replace({
        path: "/home",
        query: {
          id,
          type,
        },
      });
      this.id = id;
      this.type = type;
      this.getInfoData();
      this.getRecommendList();
      // 滚动到顶部
      this.$refs.pageContent.scrollTo(0, 0);
    },
    shareHandle() {
      const path = encodeURIComponent("Web/TestDetail");
      const params = {
        id: this.id,
        type: this.type,
      };
      const encodeParams = encodeURIComponent(JSON.stringify(params));
      const url = `${this.$ShareUrl}/share?platform=wx&linkId=usr1jvrml77haac0&path=${path}&params=${encodeParams}`;
      console.log("share 趣味测评介绍 组合url", `${this.$ShareUrl}${url}`);
      let data = {
        title: this.infoData.title,
        img: this.infoData.imageUrl,
        url: url,
      };
      console.log("share 趣味测评介绍 - bridge", data);
      this.$bridge.call("share", data);
    },
    // 返回
    back() {
      // 调用bridge close
      this.bridgeClose();
    },
    // 获取测评详情数据
    async getInfoData() {
      const res = await getFunInfo({ id: this.id });
      this.infoData = res.data;
      console.log("获取测评详情数据", this.infoData);
    },
    // 获取推荐测评列表
    async getRecommendList() {
      const res = await getRecommend({ id: this.id });
      this.recommendList = res.data;
      console.log(this.recommendList);
    },
    // 开始测试
    toAnswer() {
      this.$router.push({
        path: "/answer",
        query: {
          type: this.type,
          id: this.id,
          title: this.infoData.title,
        },
      });
    },
    // 查看报告
    toReport() {
      this.$router.replace({
        path: "/result",
        query: {
          id: this.id,
          type: this.type,
          reportId: this.infoData.latestAnswerId,
        },
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getInfoData();
    this.getRecommendList();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {
    // 添加滚动事件监听器
    this.$nextTick(() => {
      // setTimeout(() => {
      const pageContent = this.$refs.pageContent;
      const BBRef = this.$refs.BBRef;
        pageContent.scrollTop = BBRef.offsetHeight
        console.log("pageContent", pageContent);
    });
  }, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variable.scss";
$ListHeight: calc(100vh - 120px);
.container {
  color: #333333;
  // height: 100vh;
  background-color: #f3f4f6;
}
.funIntro {
  background-color: #f3f4f6;
  /* padding-bottom: 250px; */
  display: flex;
  .pageImg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
  }
  .navigator {
    width: 100vw;
    height: 85px;
    color: #292929;
    /* position: fixed; */
    top: 0px;
    left: 0;
    z-index: 1;
    .back_share {
      width: 100%;
      padding: 18px 36px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .back_img {
        width: 21px;
        height: 38px;
      }
      .nav_title {
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #292929;
        line-height: 72px;
      }
      .share_img {
        width: 38px;
        height: 38px;
      }
    }
  }
  .pageContent {
    overscroll-behavior: none;
    flex: 1;
    height: 100vh;
    overflow-y: auto;
    padding-top: 200px;
    /* position: relative; */
    top: 70px;
    left: 0;
    .blank_box {
      height: 558px;
      /* animation: expandHeight 0.8s ease-out forwards; */
      /* animation: expandHeightSmooth 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards; */
    }
    .content {
      padding: 20px;
      padding-bottom: 206px;
      border-radius: 30px 30px 0px 0px;
      background: linear-gradient(transparent 10%, #f3f4f6 20%, #f3f4f6 100%);
      .content_top {
        width: 711px;
        min-height: 184px;
        background: linear-gradient(0deg, #def6ed 0%, #f3f4f6 100%);
        border-radius: 30px 30px 0px 0px;
        .price_number {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          .price_box {
            height: 45px;
            background: linear-gradient(90deg, #79e693, #79e7ca);
            border-radius: 22px 0px 22px 0px;
            padding: 11px 20px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #ffffff;
            line-height: 22px;
            .free_text {
              margin-right: 17px;
            }
            .free_price_text {
              text-decoration: line-through;
            }
            .price_text {
            }
          }
          .number_box {
            display: flex;
            align-items: center;
            .total_num {
              display: flex;
              align-items: center;
              margin-right: 25px;
              img {
                width: 17px;
                height: 18px;
                margin-right: 9px;
              }
              span {
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 22px;
                color: #282828;
              }
            }
            .person_num {
              display: flex;
              align-items: center;
              margin-right: 31px;
              img {
                width: 19px;
                height: 19px;
                margin-right: 9px;
              }
              span {
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 22px;
                color: #282828;
              }
            }
          }
        }
        .question {
          padding: 25px 18px 79px 18px;
          font-family: PingFang SC;
          font-weight: bold;
          font-size: 30px;
          color: #222222;
        }
      }
      .content_box {
        background: #ffffff;
        border-radius: 30px;
        padding: 35px 20px 51px 20px;
        margin-top: -44px;
        .module_box {
          padding-bottom: 35px;
          border-bottom: 1px solid #ededed;
          margin-bottom: 37px;
          .content_title {
            display: flex;
            align-items: center;
            .title_line {
              width: 5px;
              height: 28px;
              background: #fade22;
              border-radius: 2px;
              margin-right: 16px;
            }
            .title_text {
              font-family: PingFang SC;
              font-size: 28px;
              font-weight: bold;
              color: #222222;
            }
          }
          .content_summary {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #282828;
            line-height: 56px;
            margin-top: 25px;
            margin-bottom: 35px;
          }
          .type_box {
            .content_img {
              width: 667px;
              height: 294px;
            }
            .content_description {
              padding: 5px 20px;
              background: #f5faf9;
              border-radius: 10px;
              .desc_item {
                display: flex;
                align-items: center;
                .desc_icon {
                  width: 56px;
                  height: 56px;
                  margin-right: 30px;
                }
                .desc_title {
                  width: 543px;
                  padding: 35px 0;
                  border-bottom: 1px solid #bde0d6;
                  .desc_text {
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 24px;
                    color: #282828;
                  }
                }
              }
              .desc_item:last-child {
                .desc_title {
                  border-bottom: none;
                }
              }
            }
            .content_description_2 {
              background-color: #ffffff;
            }
          }
          .content_conclusion {
            background: #f5faf9;
            border-radius: 10px;
            padding: 30px 20px;
            margin-top: 30px;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 24px;
            line-height: 40px;
            color: #282828;
          }
          .content_conclusion2 {
            margin-top: 20px;
            margin-bottom: 15px;
            position: relative;
            .content_conclusion_bg {
              padding: 14px 0 0 16px;
              background: linear-gradient(90deg, #9ee0c3 0%, #ffffff 46%);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #222222;
            }
            .content_conclusion_text1 {
              width: 648px;
              box-sizing: border-box;
              padding: 42px 14px 20px 16px;
              box-shadow: 0px 16px 32px 0px rgba(199, 205, 221, 0.13);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              line-height: 40px;
              color: transparent;
            }
            .content_conclusion_text2 {
              width: 648px;
              box-sizing: border-box;
              padding: 42px 14px 37px 16px;
              background: #ffffff;
              box-shadow: 0px 16px 32px 0px rgba(199, 205, 221, 0.13);
              border-radius: 10px;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 24px;
              line-height: 40px;
              color: #222222;
              position: absolute;
              top: 14px;
              left: 16px;
            }
          }
          .reference_box {
            margin-top: 19px;
            .reference_item {
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 24px;
              color: #666666;
              line-height: 40px;
              padding-bottom: 20px;
              margin-top: 20px;
              border-bottom: 1px solid #ededed;
            }
            .reference_item:last-child {
              border: none;
              padding: 0;
            }
          }
        }
        .module_box:last-child {
          border: none;
          margin: 0;
        }
      }
    }
    .recommend {
      width: 100%;
      margin-top: 25px;
      .recommend_img {
        width: 145px;
        height: 46px;
      }
      .recommend_box {
        margin-top: 20px;
        .recommend_item {
          display: flex;
          align-items: center;
          padding: 15px 20px;
          background: #ffffff;
          border-radius: 22px;
          margin-bottom: 20px;
          .recommend_item_img {
            width: 147px;
            height: 144px;
            margin-right: 18px;
            border-radius: 10px;
          }
          .recommend_item_content {
            width: 100%;
            .recommend_item_title {
              font-family: PingFang SC;
              font-size: 30px;
              font-weight: blob;
              color: #282828;
              line-height: 40px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .recommend_item_subTitle {
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #282828;
              line-height: 40px;
              width: 400px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .recommend_item_person_price {
              display: flex;
              align-items: end;
              justify-content: space-between;
              margin-top: 20px;
              .recommend_item_personNum {
                display: flex;
                align-items: center;
                .recommend_item_personNum_icon {
                  width: 22px;
                  height: 22px;
                }
                .recommend_item_personNum_text {
                  font-family: PingFang SC;
                  font-weight: 400;
                  font-size: 22px;
                  color: #282828;
                  margin-left: 8px;
                }
              }
            }
            .recommend_item_price {
              .recommend_free_text {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 26px;
                color: #f36060;
                line-height: 40px;
              }
              .recommend_item_price_free {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 26px;
                color: #f36060;
                line-height: 40px;
                margin-left: 10px;
                text-decoration: line-through;
              }
              .recommend_item_price_normal {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 26px;
                color: #f36060;
                line-height: 40px;
              }
            }
          }
        }
      }
    }
  }
  .btn_box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 34px 17px 64px 17px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: #f3f4f6;
    .btn_item {
      //   min-width: 347px;
      width: 100%;
      height: 88px;
      background: linear-gradient(90deg, #79e695, #5ad8b7);
      border-radius: 43px;
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 36px;
      color: #ffffff;
      line-height: 40px;
      margin-left: 21px;
    }
    .btn_item:first-child {
      margin: 0;
    }
  }
}
</style>
